import { AuthenticatedApp } from '@room/shared-ui';
import { CreditsPage } from './pages/CreditsPage';

export function App() {
  return (
    <AuthenticatedApp appName="Credits">
      <CreditsPage />
    </AuthenticatedApp>
  );
}
